<template>
  <!-- 品牌 -->
  <v-sheet class="brand__swiper pt-7 pb-4 xs:py-3 wd--mx-4" elevation="0" rounded>
    <div class="brand__header d-flex justify-space-between align-center wd-mb-4 wd-px-4">
      <h3 v-if="title" class="wd-text-xl xs:wd-text-2xl wd-font-500 wd-mb-0">{{ title }}</h3>

      <div v-if="!isMobile && !(disabledPrevBtn && disabledNextBtn)" class="swiper-btn-group d-flex">
        <v-btn
          class="swiper-button swiper-prev mr-3 pa-0"
          min-width="32"
          height="32"
          variant="text"
          :disabled="disabledPrevBtn"
          aria-label="Prev Button"
          @click="prevSwiper"
        >
          <FunnowSvgIcon max-width="24" :image-path="'chevron-left.svg'" />
        </v-btn>

        <v-btn
          class="swiper-button swiper-next pa-0"
          :disabled="disabledNextBtn"
          min-width="32"
          height="32"
          variant="text"
          aria-label="Next Button"
          @click="nextSwiper"
        >
          <FunnowSvgIcon max-width="24" :image-path="'chevron-right.svg'" />
        </v-btn>
      </div>
    </div>

    <div class="brand__container xs:wd-px-4">
      <swiper-vue ref="brandSwiper" v-bind="swiperOption" @swiper="initSwiper" @slide-change="switchSwiperBtnStatus">
        <swiper-slide v-for="(brand, idx) in items" :key="brand.id" class="brand__slide">
          <div v-if="brand.id" class="brand__box" @click="handleClickBrand(brand, idx)">
            <v-img class="brand__icon" :src="getImage(brand.icon_image)" cover>
              <template #placeholder>
                <v-skeleton-loader boilerplate type="image" />
              </template>
            </v-img>
          </div>
          <v-skeleton-loader v-else boilerplate type="image" class="brand__icon" />
        </swiper-slide>
      </swiper-vue>
    </div>
  </v-sheet>
</template>

<script setup>
import { Swiper as SwiperVue, SwiperSlide } from 'swiper/vue'

import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'

import { useUserInfo } from '@/composition/useMember'
import { useGtm } from '@/composition/useGtm'

import { GtmEventMap } from '@/view-models/gtm'

const props = defineProps({
  title: { type: String, default: '' },
  isMobile: { type: Boolean, default: false },
  region: { type: Object, default: () => ({}) },
  items: { type: Array, default: () => [] },
})

const config = useRuntimeConfig()
const router = useRouter()
const localePath = useLocalePath()

const { userInfo } = useUserInfo()
const { sendGtmEvent } = useGtm()

const { disabledPrevBtn, disabledNextBtn, initSwiper, prevSwiper, nextSwiper, switchSwiperBtnStatus } = useSwiperFactory()

const swiperOption = computed(() => ({
  slidesPerView: 'auto',
  spaceBetween: 20,
  slidesPerGroup: 2,
  freeMode: true,
}))

const isLogin = computed(() => !!userInfo.value)

function getImage(path) {
  if (!path) return ''
  return path.startsWith('http') ? path : `${config.public.CDN_URI}${path}`
}

function handleClickBrand(brand, idx) {
  if (props.region.id && brand.id) {
    // INFO: brand.id is category id
    router.push(localePath({ name: 'regions-rid-categories-id', params: { rid: props.region.id, id: brand.id } }))
    sendGTMHomeBrandClicked(brand, idx)
  }
}

function sendGTMHomeBrandClicked(brand, idx) {
  sendGtmEvent(
    {
      event: GtmEventMap.HOME_BRAND_CLICKED,
      payload: {
        'Brand ID': brand.id,
        'Brand Title': brand.name,
        'Region ID': props.region.id,
        'Region Name': props.region.name,
        Sequence: idx,
      },
    },
    isLogin.value
  )
}

watch(
  () => props.items,
  () => {
    switchSwiperBtnStatus()
  }
)
</script>

<style scoped lang="scss">
.brand__swiper {
  .brand__container {
    --brand-slide-size: 80px;
    @screen xs {
      --brand-slide-size: 100px;
    }
  }

  .brand__slide {
    @apply wd-w-auto;
  }

  .brand__box {
    @apply wd-cursor-pointer wd-px-2 wd-flex wd-items-center wd-justify-center;

    .brand__icon {
      @apply wd-rounded-full;
      width: var(--brand-slide-size);
      height: var(--brand-slide-size);
    }
  }
}
</style>
